<template>
    <v-row v-if="isReady" class="standard-row" v-resize="onResize" no-gutters>
        <v-overlay color="#106c68" :value="callApiPending" z-index="12">
            <span class="loader"></span>
        </v-overlay>
        <v-col cols="12" class="d-flex justify-center">
            <v-row class="standard-row mb-2" style="max-width: 1214px" no-gutters>
                <v-btn class="font-theme font-header-tabs-eval" height="52" depressed rounded text to="/eval_vendor">
                    &lt; กลับหน้ากล่องเอกสาร
                </v-btn>
            </v-row>
        </v-col>
        <v-col cols="12">
            <v-card class="font-theme evaluate-detail ma-auto mb-4 pt-7" max-width="1214px">
                <v-row class="standard-row" no-gutters>
                    <v-col cols="12">
                        <v-row class="padding-custom mb-4" align="center" no-gutters>
                            <v-col cols="12" class="title-detail d-flex align-center">
                                <img src="../assets/icon-document.svg" alt="icon-document" />
                                ประเมินผู้ขาย (Vendor)
                            </v-col>
                            <v-col cols="12">วัตถุประสงค์ในการประเมินผู้ขาย</v-col>
                            <v-col cols="12">
                                สำหรับวิเคราะห์ด้านคุณภาพ ราคา
                                การส่งมอบ และบริการ เพื่อใช้เป็นตัวชี้วัดในการเลือกใช้บริการผู้ขาย
                            </v-col>
                        </v-row>
                        <v-divider class="divider-custom"></v-divider>
                        <v-form lazy-validation ref="evalInfor">
                            <v-row class="standard-row padding-custom mb-5" align="center" no-gutters>
                                <v-col cols="12">
                                    <v-row class="standard-row" justify="start" align="center">
                                        <v-col cols="auto">
                                            <div class="topic-number">1</div>
                                        </v-col>
                                        <v-col cols="auto">
                                            <div class="topic-name px-3">ข้อมูลผู้ประเมิน</div>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-row class="standard-row" justify="start" justify-md="start" align="center">
                                        <v-col cols="auto" sm="3" class="pb-1 pr-0 pb-sm-3">ผู้ประเมิน</v-col>
                                        <v-col cols="12" sm="9" class="py-0 py-sm-3">
                                            <v-text-field :value="!isEvaluated ? fullName : evalData.evaler_name"
                                                height="41px"
                                                class="border-radius-box text-field-box-custom box-field-custom"
                                                color="black" background-color="#EAEAEA" style="border-radius: 10px"
                                                readonly hide-details outlined dense>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-row class="standard-row" justify="start" align="center">
                                        <v-col cols="auto" sm="3" class="pb-1 pr-0 pb-sm-3">
                                            หน่วยงาน/ฝ่าย
                                        </v-col>
                                        <v-col cols="12" sm="9" class="py-0 py-sm-3">
                                            <v-text-field :value="!isEvaluated ? departmentName : evalData.department"
                                                height="41px"
                                                class="border-radius-box text-field-box-custom box-field-custom"
                                                color="black" background-color="#EAEAEA" style="border-radius: 10px"
                                                readonly hide-details outlined dense>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-row class="standard-row" justify="start" align="center">
                                        <v-col cols="auto" sm="3" class="pb-1 pr-0 pb-sm-3">
                                            เลขที่ใบสั่งซื้อ (PO)
                                        </v-col>
                                        <v-col cols="12" sm="9" class="py-0 py-sm-3">
                                            <v-text-field :value="!isEvaluated ? poNumber : evalData.po_number"
                                                height="41px"
                                                class="border-radius-box text-field-box-custom box-field-custom"
                                                color="black" background-color="#EAEAEA" style="border-radius: 10px"
                                                readonly hide-details outlined dense :rules="textRules" required>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-row class="standard-row" justify="start" align="center">
                                        <v-col cols="auto" sm="3" class="pb-1 pr-0 pb-sm-3">
                                            Vendor Name
                                        </v-col>
                                        <v-col cols="12" sm="9" class="py-0 py-sm-3">
                                            <v-text-field :value="!isEvaluated ? vendorName : evalData.vendor_name"
                                                height="41px"
                                                class="border-radius-box text-field-box-custom box-field-custom"
                                                color="black" background-color="#EAEAEA" style="border-radius: 10px"
                                                readonly hide-details outlined dense :rules="textRules" required>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col
                                    v-if="evalData.detail_vendor === 'ประเมินการให้บริการได้ (ได้รับการให้บริการเเล้ว)'"
                                    cols="12" md="6">
                                    <v-row class="standard-row" justify="start" align="center">
                                        <v-col cols="auto" sm="3" class="pb-1 pr-0 pb-sm-3">
                                            เลขที่ใบสั่งซื้อ
                                        </v-col>
                                        <v-col cols="12" sm="9" class="py-0 py-sm-3">
                                            <v-text-field :value="!isEvaluated ? documentId : evalData.document_id"
                                                height="41px"
                                                class="border-radius-box text-field-box-custom box-field-custom"
                                                color="black" background-color="#EAEAEA" style="border-radius: 10px"
                                                readonly hide-details outlined dense :rules="textRules" required>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col
                                    v-if="evalData.detail_vendor === 'ประเมินการให้บริการได้ (ได้รับการให้บริการเเล้ว)'"
                                    cols="12" md="6">
                                    <v-row class="standard-row" justify="start" align="center">
                                        <v-col cols="auto" sm="3" class="pb-1 pr-0 pb-sm-3">
                                            มูลค่า PO
                                        </v-col>
                                        <v-col cols="12" sm="9" class="py-0 py-sm-3">
                                            <v-text-field :value="!isEvaluated ? netAmount : evalData.net_amount"
                                                height="41px"
                                                class="border-radius-box text-field-box-custom box-field-custom"
                                                color="black" background-color="#EAEAEA" style="border-radius: 10px"
                                                readonly hide-details outlined dense :rules="textRules" required>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col
                                    cols="12">
                                    <v-row class="standard-row" justify="start" align="center">
                                        <v-col cols="auto" sm="2" class="pb-1 pr-0 pb-sm-3 custom-col-sm-2">
                                            Description
                                        </v-col>
                                        <v-col cols="12" sm="10" class="py-0 py-sm-3 custom-col-sm-10">
                                            <v-textarea :value="!isEvaluated ? description : evalData.description"
                                                height="100px" class="box-field-custom" color="black"
                                                background-color="#EAEAEA" style="border-radius: 10px" readonly
                                                no-resize hide-details outlined dense :rules="textRules" required>
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <v-row class="standard-row" align="center">
                                        <v-col cols="auto" class="pb-1 pb-md-3">
                                            อุปกรณ์/สินค้า/บริการ ดังกล่าว สามารถตรวจรับได้หรือไม่
                                        </v-col>
                                        <v-col cols="12" md="5" class="py-0 py-md-3">
                                            <v-select class="select-box-custom box-field-custom" :readonly="isEvaluated"
                                                :style="{
                                                    width: '82%',
                                                    borderRadius: '10px',
                                                    ...(isEvaluated ? { backgroundColor: '#EAEAEA' } : {}),
                                                }" v-model="evalData.detail_vendor" :items="items"
                                                append-icon="mdi mdi-chevron-down" item-color="#000000" color="black"
                                                height="41px" :menu-props="{ bottom: true, offsetY: true }" hide-details
                                                outlined dense :rules="textRules" required>
                                                <template v-slot:item="data">
                                                    <v-list-item-content>
                                                        <v-list-item-title class="font-theme" style="line-height: 30px">
                                                            {{ data.item }}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-divider v-if="evalData.detail_vendor !== 'ยังไม่ได้รับสินค้าหรือการให้บริการ'"
                            class="divider-custom">
                        </v-divider>
                        <v-form lazy-validation ref="dateCheckInfor">
                            <v-row v-if="evalData.detail_vendor !== 'ยังไม่ได้รับสินค้าหรือการให้บริการ'"
                                class="standard-row padding-custom mb-5" align="center" no-gutters>
                                <v-col cols="12">
                                    <v-row class="standard-row" justify="start" align="center">
                                        <v-col cols="auto">
                                            <div class="topic-number">2</div>
                                        </v-col>
                                        <v-col cols="auto">
                                            <div class="topic-name px-3">ข้อมูลวันที่ตรวจรับ</div>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12">
                                    <v-row class="standard-row" align="center">
                                        <v-col cols="auto" class="pb-1 pb-sm-3">
                                            วันที่ตรวจรับอุปกรณ์/สินค้า/บริการโดยประมาณการ
                                        </v-col>
                                        <v-col cols="12" sm="5" class="py-0 py-sm-3">
                                            <v-menu v-model="menu" :close-on-content-click="false"
                                                transition="scale-transition" offset-y min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        class="border-radius-box text-field-box-custom box-field-custom"
                                                        v-bind="attrs" v-on="!isEvaluated ? on : {}"
                                                        v-model="receiptDate" :readonly="isEvaluated" :style="{
                                                            width: '82%',
                                                            borderRadius: '10px',
                                                            ...(isEvaluated ? { backgroundColor: '#EAEAEA' } : {}),
                                                        }" color="black" :clearable="!isEvaluated" height="41px"
                                                        @click:clear="isEvaluated ? clearDate : null" hide-details
                                                        outlined dense :rules="textRules" required>
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker color="#0B68D6" v-model="evalData.receipt_date"
                                                    :readonly="isEvaluated"
                                                    :max="new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)"
                                                    no-title show-current locale="th" @input="updateDate"
                                                    class="font-theme">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-divider class="divider-custom"></v-divider>
                        <v-form lazy-validation ref="evalVendor">
                            <v-row v-if="evalData.detail_vendor !== 'ยังไม่ได้รับสินค้าหรือการให้บริการ'"
                                class="standard-row padding-custom" align="center" no-gutters>
                                <v-col cols="12">
                                    <v-row class="standard-row" justify="start" align="center">
                                        <v-col cols="auto">
                                            <div class="topic-number">3</div>
                                        </v-col>
                                        <v-col cols="auto">
                                            <div class="topic-name px-3">การประเมินผู้ขาย</div>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12">
                                    <v-row class="standard-row" align="center">
                                        <v-col cols="12" class="tital-eval-criteria pt-0 pb-0">
                                            <p class="mb-0">
                                                เกณฑ์การประเมินให้เลือกคะแนนในช่องโดยเลือกระดับความมากน้อยหรือความพึงพอใจดังนี้
                                                <span>
                                                    5 = ดีมาก 4 = ดี 3 = ปานกลาง 2 = พอใช้ 1 = ปรับปรุง
                                                </span>
                                            </p>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" class="mb-4">
                                    <v-row class="standard-row" align="center">
                                        <v-col cols="12">
                                            <v-data-table :headers="headersEvaluate" :items="itemsEvaluate"
                                                item-value="name" disable-pagination fixed-header disable-sort
                                                hide-default-footer class="table-evaluate-detail table-evaluate">
                                                <template v-slot:[`item.name`]="{ item }">
                                                    <v-row class="standard-row" justify="center" align="center">
                                                        <v-col cols="12">
                                                            <p class="mb-1 pl-6">{{ item.name }}</p>
                                                            <small v-html="item.description"></small>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <template v-for="(n, index) in [5, 4, 3, 2, 1]"
                                                    v-slot:[`item.${n}`]="{ item }">
                                                    <v-radio-group v-model="item.score" hide-details
                                                        class="radio-group-custom" :key="index" :readonly="isEvaluated"
                                                        :rules="[(v) => v !== null && v !== undefined && v !== '',]"
                                                        required>
                                                        <v-radio class="radio-custom" :value="n" :ripple="false">
                                                        </v-radio>
                                                    </v-radio-group>
                                                </template>
                                            </v-data-table>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-row class="standard-row padding-custom" align="center">
                            <v-col cols="12">
                                <v-row class="standard-row" align="center">
                                    <v-col cols="auto" class="pb-0 pb-sm-3">ข้อเสนอเเนะ</v-col>
                                    <v-col cols="12" sm="4" class="py-0 py-sm-3">
                                        <v-text-field v-model="evalData.feedback"
                                            class="border-radius-box text-field-box-custom box-field-custom" :style="{
                                                borderRadius: '10px',
                                                ...(isEvaluated ? { color: 'black', backgroundColor: '#EAEAEA' } : {}),
                                            }" :readonly="isEvaluated" height="41px" color="black" hide-details
                                            outlined dense>
                                        </v-text-field>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col cols="12" sm="auto" class="text-center">
                                        <v-btn class="btn-custom" :disabled="isEvaluated" width="125px" height="50px"
                                            color="white" text @click="sendEval()" depressed>
                                            ส่งประเมิน
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import { EventBus } from "@/EventBus";
import { MainFunction } from "@/functions/mainFunction";
export default {
    data: () => ({
        textRules: [(v) => !!v],
        callApiPending: 0,
        transaction_id: null,
        permission_tabs: "",
        status: "",
        isReady: false,
        isEvaluated: false,
        evalData: {},
        menu: false,
        eval_vendor_scores: [],
        items: ["ประเมินการให้บริการได้ (ได้รับการให้บริการเเล้ว)", "ยังไม่ได้รับสินค้าหรือการให้บริการ",],
        headersEvaluate: [
            { text: "", value: "name", align: "start", width: "300px" },
            { text: "(5) ดีมาก", value: 5, align: "center", width: "120px" },
            { text: "(4) ดี", value: 4, align: "center", width: "120px" },
            { text: "(3) ปานกลาง", value: 3, align: "center", width: "120px" },
            { text: "(2) ปรับปรุง", value: 2, align: "center", width: "120px" },
            { text: "(1) พอใช้", value: 1, align: "center", width: "120px" },
        ],
        itemsEvaluate: [
            {
                name: "คุณภาพ Quality",
                description:
                    "<ul><li>ลักษณะการให้บริการ/ Specification ตรงตามข้อเสนอโครงการหรือตามเอกสาร Purchase Order</li><li>รายการวัสดุ/ รายการอุปกรณ์/ รายการสิ่งส่งมอบเเละผลงาน ถูกต้อง,ครบถ้วน, รายละเอียดชัดเจน</li><li>มีการ Warranty สินค้าอย่างชัดเจนพร้อมทั้งติดตามการเข้าดําเนินการตรงตามรอบระยะเวลา</li><li>มีใบรับประกันหรือใบรับรองคุณภาพด้านมาตรฐานของสินค้าเเละบริการ เช่น มาตรฐานผลิตภัณฑ์อุตสาหกรรม (มอก.) มาตรฐานระบบการจัดการคุณภาพ ISO 9000 เป็นต้น</li></ul>",
                eval_name: "Quality",
                score: "",
            },
            {
                name: "ราคา Price",
                description:
                    "<ul><li>ราคาสินค้าหรือบริการเป็นไปตามราคาตลาด ในกรณีเป็นบริการที่เฉพาะเจาะจงต้องสามารถตรวจสอบข้อมูลให้บริการเเละราคาได้</li><li>สามารถต่อรองราคาสินค้าได้ โดยประสิทธิภาพของสินค้าเเละบริการยังเป็นไปตามขอบเขต</li><li>เงื่อนไขการชําระมีระยะเวลาที่เหมาะสม เป็นไปตามที่ตกลงไว้หมายเหตุ * ในกรณีประเมินผู้ขายภายใน (Internal Supplier) ไม่ต้องประเมินในหมวดดังกล่าว</li></ul>",
                eval_name: "Price",
                score: "",
            },
            {
                name: "การส่งมอบ Delivery",
                description:
                    "<ul><li>มีความต่อตรงต่อเวลาตามที่ตกลงไว้ในข้อเสนอโครงการหรือตามเอกสาร Purchase Order</li><li>จัดส่งตามสถานที่ที่บริษัทกําหนดได้อย่างถูกต้อง</li><li>มีการนําส่งเอกสารการส่งมอบงาน / Service Report โดยมีการลงนามเรื่องการส่งมอบบริการอย่างชัดเจน</li></ul>",
                eval_name: "Delivery",
                score: "",
            },
            {
                name: "บริการ Service",
                description:
                    "<ul><li>มีความรวดเร็วในการให้บริการ ตามที่ตกลงไว้ในข้อเสนอโครงการหรือตามเอกสาร Purchase Order</li><li>มีช่องทางการติดต่อสื่อสารเพื่อสนับสนุนโดยหน่วยงานภายใน /ระบบงาน Call Center โดยมีการรับเรื่องการขอรับบริการอย่างชัดเจน</li></ul>",
                eval_name: "Service",
                score: "",
            },
        ],
        headerEvalCriteria: [
            { text: "Grade", value: "grade", align: "center", width: "108px" },
            { text: "แนวทางการจัดการ", value: "manage", align: "center", width: "414px", },
            { text: "ผลรวมคะแนน", value: "score", align: "center", width: "200px" },
        ],
    }),
    computed: {
        receiptDate: {
            get() {
                return MainFunction.shortDate(this.evalData.receipt_date);
            },
            set(value) {
                this.evalData.receipt_date = value;
            },
        },
        raDetail() {
            return this.$store.state.raDetail;
        },
        evalDetail() {
            return this.$store.state.evalDetail;
        },
        evaluatedData() {
            return this.$store.state.evaluatedData;
        },
        selectedBiz() {
            return this.$store.state.confirmSelectedBiz;
        },
        fullName() {
            return `${this.raDetail.first_name_th} ${this.raDetail.last_name_th}`;
        },
        departmentName() {
            return `${this.raDetail.orgchart.department[0].orgChartName}`;
        },
        transactionIdStatus() {
            return this.evaluatedData.id;
        },
        permissionTabsStatus() {
            return this.evaluatedData.permissionTabs;
        },
        statusStatus() {
            return this.evaluatedData.status;
        },
        transactionId() {
            return this.evalDetail[0].transaction_id;
        },
        evalType() {
            return this.evalDetail[0].eval_type;
        },
        poNumber() {
            return this.evalDetail[0].po_number;
        },
        vendorName() {
            return this.evalDetail[0].vendor_name;
        },
        documentId() {
            return this.evalDetail[0].document_id;
        },
        netAmount() {
            return this.evalDetail[0].net_amount;
        },
        description() {
            return this.evalDetail[0].description;
        },
    },
    watch: {
        "callApiPending"(val) {
            if (val > 0) {
                EventBus.$emit('loadingState', true)
            } else {
                EventBus.$emit('loadingState', false)
            }
        },
    },
    mounted() {
        this.onResize();
        this.setDataStatus()
    },
    beforeDestroy() {
        this.callApiPending = 0;
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth };
        },
        updateDate(value) {
            this.evalData.receipt_date = value;
            this.menu = false;
        },
        clearDate() {
            this.evalData.receipt_date = "";
        },
        async setDataStatus() {
            const saveStatus = this.statusStatus;
            this.transaction_id = this.transactionIdStatus;
            this.permission_tabs = this.permissionTabsStatus;

            if (this.evaluatedData) {
                this.evaluatedData.status = "";
            }

            this.status = "";

            if (saveStatus !== undefined && saveStatus !== null) {
                this.status = saveStatus;
            }

            if (this.status === 'success' || this.status === 'incomplete') {
                this.isEvaluated = true;
                this.getEvaluatedData();
            } else {
                this.isEvaluated = false;
                this.isReady = true;
            }
        },
        async sendEval() {
            try {
                this.callApiPending++;
                this.$refs.evalInfor.validate();
                this.$refs.dateCheckInfor.validate();
                this.$refs.evalVendor.validate();
                if (!this.$refs.evalInfor.validate() || !this.$refs.dateCheckInfor.validate() || !this.$refs.evalVendor.validate()) {
                    this.alert("กรุณากรอกข้อมูลให้ครบ", "Warning", "info");
                    return;
                }
                this.eval_vendor_scores = this.itemsEvaluate.map(
                    ({ eval_name, score }) => ({
                        eval_name,
                        score: Number(score),
                    })
                );
                const dataEvalVendor = {
                    tax_id: this.selectedBiz.tax_id,
                    transaction_id: this.transactionId,
                    eval_type: this.evalType,
                    document_id: this.documentId,
                    po_number: this.poNumber,
                    vendor_name: this.vendorName,
                    net_amount: this.netAmount,
                    description: this.description,
                    detail_vendor: this.evalData.detail_vendor,
                    feedback: this.evalData.feedback || "-",
                };
                if (this.evalData.detail_vendor === "ประเมินการให้บริการได้ (ได้รับการให้บริการเเล้ว)") {
                    dataEvalVendor.receipt_date = this.evalData.receipt_date;
                    dataEvalVendor.eval_vendor_scores = this.eval_vendor_scores;
                }
                const { data } = await this.axios.post(`${this.$api_url}/saler_score/api/v1/create_eval_vendor_saler_score`, dataEvalVendor);
                if (data.status) {
                    this.alert('ประเมินสำเร็จ', 'Success', 'success')
                    this.$router.push({ path: "/eval_vendor" })
                } else {
                    this.alert('ประเมินไม่สำเร็จ', 'Fail', 'error')
                }
            } catch (error) {
                if (error.response.data?.message === "Eval not possible") {
                    this.alert("ไม่สามารถประเมินผู้ขาย\n กรุณาเลือกประเภทการตรวจรับใหม่", "Fail", "error")
                }
                else {
                    this.alert("ประเมินไม่สำเร็จ", "Fail", "error");
                }
            } finally {
                this.callApiPending--;
                if (!this.callApiPending) this.isReady = true;
            }
        },
        async getEvaluatedData() {
            try {
                this.callApiPending++;
                const { data } = await this.axios.get(
                    `${this.$api_url}/saler_score/api/v1/data_saler_score?transaction_id=${this.transaction_id}&eval_type=${this.permission_tabs}`
                );
                if (data.status && data.data) {
                    const responce = data.data;
                    for (const item of responce.eval_vendor_scores) {
                        const scoreData = this.itemsEvaluate.find((i) => i.eval_name === item.eval_name);
                        if (scoreData) {
                            scoreData.score = item.score;
                        }
                    }
                    this.evalData = responce;
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.callApiPending--;
                if (!this.callApiPending) this.isReady = true;
            }
        },
        alert(title = "", text = "", icon = "info") {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text: text,
                showClass: {
                    popup: "animate-show-card",
                },
                customClass: {
                    container: "alert-card-block",
                    popup: "alert-card-success",
                    title: "alert-title-block",
                    htmlContainer: "alert-text-box",
                    icon: "alert-icon",
                },
            });
        },
    },
};
</script>

<style>
.evaluate-detail {
    font-size: 16px;
    font-weight: 200;
    color: #000000 !important;
}

.padding-custom {
    padding: 0 39px;
}

.divider-custom {
    border-color: #aeaeae;
}

.btn-custom.v-btn--disabled {
    background-color: #eaeaea;
}

.custom-col-sm-2 {
    flex: 0 0 12.5%;
    max-width: 12.5%;
}

.custom-col-sm-10 {
    flex: 0 0 87.5%;
    max-width: 87.5%;
}

.title-detail {
    font-size: 32px;
    color: #0c0c0c;
    margin-bottom: 18px;
}

.evaluate-detail.v-sheet.v-card {
    background-color: #ffffff;
    box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.25);
    border-radius: 23px;
}

.topic-number {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 29px;
    font-weight: bold;
    border-radius: 4px;
    border: 1px solid #000000;
}

.topic-name {
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    height: 43px;
    font-size: 20px;
    font-weight: bold;
    color: #ffffff;
    background-color: #0b68d6;
    border-radius: 11px;
}

.tital-eval-criteria>p>span {
    display: block;
    word-wrap: break-word;
}

.box-field-custom .v-icon.v-icon {
    font-size: 30px;
    margin-right: 10px;
}

.box-field-custom.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot,
.box-field-custom.v-textarea.v-text-field--enclosed .v-text-field__slot {
    padding-right: 0;
    font-size: 16px;
    font-weight: 400;
    margin-right: 10px;
}

.theme--light.select-box-custom .v-select__selections,
.theme--light.text-field-box-custom input {
    color: #000000;
}

.box-field-custom .v-input__append-inner {
    align-self: center;
}

.box-field-custom.v-text-field--outlined fieldset {
    border-radius: 10px;
}

.theme--light.table-evaluate-detail.v-data-table--fixed-header thead th:first-child {
    border-radius: 20px 0 0 0;
}

.theme--light.table-evaluate-detail.v-data-table--fixed-header thead th:last-child {
    border-radius: 0 20px 0 0;
}

.theme--light.table-evaluate-detail>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:not(.v-data-table__mobile-row) {
    border-bottom: none;
}

.table-score>.v-data-table__wrapper>table>tbody>tr>td {
    height: auto;
    padding-top: 10px;
    padding-bottom: 10px;
    word-break: break-word;
}

.theme--light.table-evaluate-detail>.v-data-table__wrapper>table>thead>tr>th,
.table-evaluate-detail>.v-data-table__wrapper>table>tbody>tr>td {
    color: #000000;
    font-size: 16px;
    font-weight: 400;
}

.theme--light.table-score {
    background-color: rgba(238, 226, 226, 0.38);
    border: 1px solid #ffffff;
    border-radius: 20px;
}

.theme--light.table-score.v-data-table--fixed-header thead th {
    background: rgba(238, 226, 226, 0.38);
    box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.21);
}

.table-score.v-data-table--fixed-header thead th:first-child,
.table-score>.v-data-table__wrapper>table>tbody>tr>td:first-child {
    border-right: 1px solid rgba(0, 0, 0, 0.21);
}

.table-score.v-data-table--fixed-header thead th:last-child,
.table-score>.v-data-table__wrapper>table>tbody>tr>td:last-child {
    border-left: 1px solid rgba(0, 0, 0, 0.21);
}

.theme--light.table-score>.v-data-table__wrapper>table>tbody>tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background-color: transparent;
}

.theme--light.table-evaluate.v-data-table--fixed-header thead th {
    background: #d9d9d9;
    box-shadow: none;
}

.radio-group-custom.v-input--selection-controls {
    margin: 0;
    padding: 0;
}

.radio-custom {
    display: flex;
    justify-content: center;
    align-items: center;
}

.radio-custom>.v-input--selection-controls__input {
    margin-right: 0;
    height: 30px;
    width: 30px;
}

.radio-custom>.v-input--selection-controls__input>.v-icon.v-icon {
    font-size: 30px;
    color: #000000;
}

.radio-custom .mdi-radiobox-blank::before {
    font-family: "Material Design Icons Light";
    content: "\F764";
}

.table-evaluate .v-data-table__mobile-row__cell {
    text-align: start;
}

@media only screen and (max-width: 959px) {
    .custom-col-sm-2 {
        flex: 0 0 25%;
        max-width: 25%;
    }

    .custom-col-sm-10 {
        flex: 0 0 75%;
        max-width: 75%;
    }
}

@media only screen and (max-width: 599px) {
    .custom-col-sm-2 {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%;
    }

    .custom-col-sm-10 {
        flex: 0 0 100%;
        max-width: 100%;
    }
}
</style>
